<template>
  <V2Modal
    :show="show"
    title="Clear my cart"
    size="sm"
    @close="$emit('on-close-modal')"
  >
    <div class="v2-clear-carts-modal__body">
      <p class="v2-text-sm v2-mb-2">
        The cart will be permanently cleared
      </p>
      <p class="v2-text-sm">
        Are you sure you want to proceed?
      </p>
    </div>
    <template #footer>
      <V2Button
        variant="outline"
        @click="$emit('on-close-modal')"
      >
        Cancel
      </V2Button>
      <V2Button
        variant="destructive"
        @click="$emit('on-click-clear-cart')"
      >
        Yes, clear it
      </V2Button>
    </template>
  </V2Modal>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'

export default {
  name: 'V2ClearCartsModal',
  components: {
    V2Modal,
    V2Button,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['on-click-clear-cart', 'on-close-modal'],
}
</script>

<style lang="scss" scoped>
.v2-clear-carts-modal__body {
  p {
    color: var(--v2-foreground);
    margin: 0;
  }

  .v2-mb-2 {
    margin-bottom: 0.5rem;
  }
}
</style>
